@if (custom && pins) {
  <main class="theme4d">
    @if (custom) {
      @if (assets) {
        <section>
          <app-setpoint-query [saveState]="false" [showValue]="true" view="compact" [asset]="assets[0]" [fullscreen]="false" dateType="custom" [custom]="custom" [pins]="pins"> </app-setpoint-query>
        </section>
      }
    }
    @if (alarm) {
      <section class="timeline">
        <app-rulesv3-item-alarm-timeline [alarm]="alarm"></app-rulesv3-item-alarm-timeline>
      </section>
    }
  </main>
}
